// @flow
import React from "react"
import { connect } from "react-redux"

import cuckoo from "common/services/cuckoo/cuckoo"
import { currencySelector } from "common/services/currencies/selectors"
import CheckBoxField from "common/components/CheckBoxField/CheckBoxField"
import Button from "common/components/Button/Button"
import Price from "common/components/Price/Price"
import translate from "../../tools/translate"
import Translate from "../../components/Translate"

type Props = {
  // eslint-disable-next-line react/require-default-props
  promo?: {
    amount: number,
    unit: string,
  },
  currency: string,
}

type State = {
  email: string,
  legalChecked: boolean,
  processed: boolean,
  showUncheckedError: boolean,
}

class SubscriptionModal extends React.Component<Props, State> {
  state = {
    email: "",
    legalChecked: false,
    processed: false,
    showUncheckedError: false,
  }

  componentDidMount() {
    if (this.props.promo) {
      cuckoo.infinario("exit_banner", { action: "shown" })
    }
  }

  componentWillUnmount() {
    if (this.props.promo && !this.state.processed) {
      cuckoo.infinario("exit_banner", { action: "closed" })
    }
  }

  toggleLegal = () => this.setState(state => ({ legalChecked: !state.legalChecked }))

  processSubscription = e => {
    e.preventDefault()

    if (!this.state.legalChecked) {
      this.setState({ showUncheckedError: true })
      return
    }

    cuckoo.infinario("subscription", { email: this.state.email, subscribed: true })
    if (this.props.promo) {
      cuckoo.infinario("exit_banner", { action: "submit" })
    }

    this.setState({ processed: true, showUncheckedError: false })
  }

  handleEmailChange = e => {
    this.setState({ email: e.target.value })
  }

  renderUncheckedError = () => (
    <div className="message error">
      <Translate tKey="account.subscription.unchecked_agreement" />
    </div>
  )

  renderSuccess = () => (
    <div className="message success">
      <Translate tKey="account.subscription.successfully_subscribed" />
    </div>
  )

  renderForm = promo => (
    <div className="Subscription-Form">
      {promo && (
        <div className="SubscriptionModal-Form-Text">
          <Translate tKey="subscription.receive_more_deals" />
        </div>
      )}

      <form className="Subscription-Form--inputs" onSubmit={this.processSubscription}>
        <span className="label">
          <Translate tKey="price_alert.web.email" />
        </span>

        <div className="Subscription-Form--wrapper">
          <div className="input-element spField-input">
            <input
              autoComplete="on"
              type="email"
              name="email"
              value={this.state.email}
              onChange={this.handleEmailChange}
              placeholder={translate("price_alert.web.email_placeholder")}
              required
              className="spField-input-raw"
            />
          </div>
          <div className="input-element">
            <div className="Button-wrapper">
              <Button type="submit">
                {promo ? (
                  <Translate tKey="subscription.subscribe" />
                ) : (
                  <Translate tKey="common.subscribe" />
                )}
              </Button>
            </div>
          </div>
        </div>

        <CheckBoxField
          checked={this.state.legalChecked}
          bordered={false}
          middle
          onChange={this.toggleLegal}
        >
          {promo ? (
            <Translate tKey="subscription.privacy_policy" />
          ) : (
            <Translate tKey="account.subscription.agreement" />
          )}
        </CheckBoxField>
        {this.state.showUncheckedError && this.renderUncheckedError()}
        <Translate
          tKey="common.subscription_privacy_policy"
          className="Subscription-Form--consent"
        />
      </form>
    </div>
  )

  renderConvertedCurrency = promo => (
    <span>
      <span>{`(${promo.amount} ${promo.unit} ~ `}</span>
      <Price>{promo.amount}</Price>
      <span>)</span>
    </span>
  )

  render() {
    const { promo, currency } = this.props
    return (
      <div className="SubscriptionModal-Content" data-test="SubscriptionModal">
        <div className="SubscriptionModal-Content-Top">
          {promo && (
            <div>
              <Translate
                tKey="subscription.promo.text"
                values={promo}
                className="SubscriptionModal-Content-Promo-Text"
              />
              {currency !== "eur" && this.renderConvertedCurrency(promo)}
              <Translate
                tKey="subscription.promo.code"
                values={promo}
                className="SubscriptionModal-Content-Promo-Code"
              />
            </div>
          )}

          <img
            src="/images/subscription/subscription.png"
            srcSet="/images/subscription/subscription@2x.png 2x, /images/subscription/subscription@3x.png 3x"
          />

          {!promo && (
            <div>
              <div className="SubscriptionModal-Content-Top-Header">
                <Translate tKey="common.subscribe" />
                {/* "subscription.subscribe_header" */}
              </div>
              <div className="SubscriptionModal-Content-Top-Text">
                {/* <Translate tKey="subscription.subscribe_text" /> */}
              </div>
            </div>
          )}
        </div>
        {this.state.processed ? this.renderSuccess() : this.renderForm(promo)}
      </div>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({ currency: currencySelector(state) }))(SubscriptionModal)
